module.exports = __webpack_public_path__ + "img/bg_m.33b65c18.jpg";